export const withQuotesRemoved = font => font.replace(/["']/g, '');
export const toTitleCaseWithoutQuotes = font => withQuotesRemoved(font).replace(/\b\w/g, char => char.toUpperCase());
export const formatFontDisplayName = font => toTitleCaseWithoutQuotes(font.split(',')[0]);
//# sourceMappingURL=formatFontDisplayName.js.map